import Link from "next/link";
import styles from "./navbar.module.scss";
import Profile from "../../../../shared-assets/Svg/Profile.svg";
import Club from "../../../../shared-assets/Svg/Club.svg";
import Category from "../../../../shared-assets/Svg/Category.svg";
import DigitoonFun from "../../../../shared-assets/Svg/DigitoonFun.svg";
import Home from "../../../../shared-assets/Svg/Home.svg";
import { ROUTES } from "../../../services/router-services";
import { useRouter } from "next/router";
import { API } from "../../../services/api-services";
import AppContext from "../../../services/app-context-services";
import { useContext } from "react";
import { trackEvent } from "../../../services/ga-services";
import { ToPersianNumber } from "../helper/helper";
import Image from "next/image";
const Navbar = () => {
  const appCtx = useContext(AppContext);
  const { isLoggedIn, profile } = appCtx;
  const router = useRouter();
  const pathname = router.pathname;
  const active = { stroke: "#FF9700", color: "#FF9700", fontWeight: 900 };
  return (
    <nav className={styles.navbarMobile}>
      <div className={styles.navbarContainer}>
        <Link href={ROUTES.root} prefetch={false}>
          <a
            className={styles.navbarIcon}
            style={pathname === "/" ? active : {}}
            onClick={() => {
              trackEvent("Navigation bar", "Home");
            }}
          >
            <Home className={styles.svg} />
            <span>دیجیتون</span>
            {/* <span className={styles.notic}></span> */}
          </a>
        </Link>
        {/* <Link href={API.club_site} prefetch={false}>
          <a
            className={styles.navbarIcon}
            onClick={() => {
              trackEvent("Navigation bar", "Club");
            }}
          >
            <Club className={styles.svg} />
            <span>کلاب</span>
            <span className={styles.notic}></span>
          </a>
        </Link> */}
        <a
          href={API.digitoon_fun}
          className={styles.digitoonFunIcon}
          onClick={() => {
            trackEvent("Navigation bar", "Digitoon fun");
          }}
        >
          <DigitoonFun className={styles.digitoonFunSvg} />
          <span>دیجیتون‌ فان</span>
          {/* <span className={styles.notic}></span> */}
        </a>
        <Link href={ROUTES.categories} prefetch={false}>
          <a
            className={styles.navbarIcon}
            style={pathname === "/category" ? active : {}}
            onClick={() => {
              trackEvent("Navigation bar", "Category");
            }}
          >
            <Category className={styles.svg} />
            <span>دسته‌بندی</span>
            {/* <span className={styles.notic}></span> */}
          </a>
        </Link>
        {isLoggedIn ? (
          <Link href={ROUTES.menu} prefetch={false}>
            <a
              className={styles.navbarIcon}
              onClick={() => {
                trackEvent("Navigation bar", "Profile");
              }}
            >
              <img
                src={profile?.avatar}
                width={30}
                height={30}
                alt="avatar"
                style={{ borderRadius: "30px" }}
              />
              <span className={styles.nickname}>
                {profile?.nickname
                  ? profile?.nickname
                  : profile?.mobile
                  ? ToPersianNumber(profile?.mobile)
                  : profile?.email}
              </span>
              {/* <span className={styles.notic}></span> */}
            </a>
          </Link>
        ) : (
          <Link href={ROUTES.login} prefetch={false}>
            <a
              className={styles.navbarIcon}
              onClick={() => {
                trackEvent("Navigation bar", "Profile");
              }}
              style={pathname === "/login" ? active : {}}
            >
              <Profile className={styles.svg} />
              <span>ورود</span>
            </a>
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
